import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { getSavingsOpportunitiesFixedCacheKey } from "@/store/savings-opportunities/utils/helpers/fixedCacheKeys";

export const postOrganisationsCurrentSavingsOpportunitiesSelector = (
  resourceId?: string,
) =>
  cloudChiprApi.endpoints.postOrganisationsCurrentSavingsOpportunities.select(
    getSavingsOpportunitiesFixedCacheKey(resourceId),
  );
